import React from 'react';
import { FaBox, FaTruck, FaTruckLoading, FaCheckCircle } from 'react-icons/fa';
import {miladiToShamsi} from "../../utils/miladiToShamsi";

const ShipmentTracker = ({ shipment, isCustomer }) => {
  const steps = [
    { label: 'تایید محموله', key: 'approved_at', icon: <FaBox /> },
    { label: 'آماده سازی', key: 'processed_at', icon: <FaTruckLoading /> },
    { label: 'تحویل به حامل', key: 'shipped_at', icon: <FaTruck /> },
    { label: 'تحویل به مشتری', key: 'delivered_at', icon: <FaCheckCircle /> },
  ];

  const deliveryMethodMap = {
  pickup: 'تحویل حضوری',
  carrier: 'شرکت حمل',
  supplier: 'ارسال تأمین کننده'
};

  // تبدیل تاریخ به شمسی (در صورت نیاز به پکیج شمس یا Intl)
  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    return new Date(dateStr).toLocaleDateString('fa-IR');
  };

  return (
    <div className="bg-white p-6 rounded-xl border border-gray-100 mb-6">
      {/* Shipment Info Grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10 text-sm">
        <div className="flex flex-col gap-1">
          <span className="font-bold text-gray-400 flex items-center gap-2">
             تأمین کننده
          </span>
          <span className="text-gray-700 font-medium">{shipment.supplier_name}</span>
        </div>
        <div className="flex flex-col gap-1">
          <span className="font-bold text-gray-400">روش ارسال</span>
          <span className="text-gray-700 font-medium">
            {deliveryMethodMap[shipment.delivery_method_title] || '---'}
          </span>
        </div>
        <div className="flex flex-col gap-1">
          <span className="font-bold text-gray-400">تاریخ تحویل</span>
          <span className="text-gray-700 font-medium tabular-nums">{miladiToShamsi(shipment.delivery_date) || '---'}</span>
        </div>
        <div className="flex flex-col gap-1">
          <span className="font-bold text-gray-400">آدرس تحویل</span>
          <span className="text-gray-700 font-medium tabular-nums">{shipment.shipping_address_text || '---'}</span>
        </div>
      <div className="flex flex-col gap-1">
          <span className="font-bold text-gray-400">ارزش کل (تومان)</span>
          <span className="text-gray-700 font-medium tabular-nums">{Number(shipment.total_amount).toLocaleString() || '---'}</span>
        </div>
      <div className="flex flex-col gap-1">
          <span className="font-bold text-gray-400">هزینه ارسال (تومان)</span>
          <span className="text-gray-700 font-medium tabular-nums">{Number(shipment.delivery_cost).toLocaleString() || '---'} تومان</span>
        </div>
      <div className="flex flex-col gap-1">
          <span className="font-bold text-gray-400">وزن کل</span>
          <span className="text-gray-700 font-medium tabular-nums">{shipment.total_weight || '---'}</span>
        </div>
          {isCustomer &&(<div className="flex flex-col gap-1">
          <span className="font-bold text-gray-400">کد ارسال</span>
          <span className="text-gray-700 font-medium tabular-nums">{shipment.delivery_code || '---'}</span>
        </div>)}
      </div>

      {/* Tracker Steps (Without Lines) */}
      <div className="flex items-start justify-center gap-4 md:gap-12 w-full max-w-4xl mx-auto overflow-x-auto py-4">
        {steps.map((step, index) => {
          // در داده‌های شما از فیلدهای متفاوتی استفاده شده، اینجا بر اساس status یا وجود فیلد زمان چک می‌کنیم
          // برای مثال اگر در محموله PENDING_APPROVING است، مراحل بعدی غیرفعال باشند
          const isCompleted = !!shipment[step.key];

          return (
            <div key={index} className="flex flex-col items-center min-w-[100px]">
              {/* Circle Icon */}
              <div
                className={`w-14 h-14 rounded-2xl flex items-center justify-center text-2xl transition-all duration-300
                ${isCompleted 
                  ? 'bg-green-500 text-white shadow-lg shadow-green-100' 
                  : 'bg-gray-50 text-gray-300 border border-gray-100'}`}
              >
                {step.icon}
              </div>

              {/* Labels */}
              <div className="mt-4 text-center">
                <p className={`text-[11px] md:text-xs font-bold leading-tight
                  ${isCompleted ? 'text-gray-800' : 'text-gray-400'}`}>
                  {step.label}
                </p>
                {isCompleted && (
                  <p className="text-[10px] text-gray-500 mt-1 tabular-nums font-medium">
                    {formatDate(shipment[step.key])}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ShipmentTracker;
